var map = {
	"./en/assessment.json": 337,
	"./en/confirmation.json": 8074,
	"./en/forms.json": 7766,
	"./en/general.json": 1797,
	"./en/home.json": 2754,
	"./en/legal.json": 3552,
	"./fr/assessment.json": 3630,
	"./fr/confirmation.json": 4608,
	"./fr/forms.json": 8472,
	"./fr/general.json": 1378,
	"./fr/home.json": 2770,
	"./fr/legal.json": 4544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2495;